import type { SingleItemArray } from '@mntn-dev/utility-types'

export function isSingleItemArray<ItemType>(
  arr: ItemType[] | undefined
): arr is SingleItemArray<ItemType> {
  return (arr && arr.length === 1) === true
}
